//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MZPopup',
  props: {
    show: {
      type: Boolean,
      required: false,
      default: true
    },
    title: {
      type: String,
      required: false,
      default: '提示'
    }
  },
  methods: {
    CloseDialog () {
      this.$emit('closeDialog')
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/_mengzhua-ui@1.1.4@mengzhua-ui/components/popup/index.vue